// TableComponent.js

import React, { Component } from "react";
import "./groupTable.css"; // Import CSS file for styling

class GroupTable extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: [],
      sortColumn: null,
      sortDirection: 'asc',
    };
  }

  // Lifecycle method to set initial state from props
  componentDidMount() {
    this.setState({ data: this.props.data });
  }

  componentDidUpdate(prevProps) {
    if (prevProps.data !== this.props.data) {
      this.setState({ data: this.props.data });
    }
  }

  handleSort = (columnKey) => {
    const { data, sortColumn, sortDirection } = this.state;
    let newSortDirection = 'asc';

    if (sortColumn === columnKey && sortDirection === 'asc') {
      newSortDirection = 'desc';
    }

    const sortedData = [...data].sort((a, b) => {
      if (a[columnKey] < b[columnKey]) {
        return newSortDirection === 'asc' ? -1 : 1;
      }
      if (a[columnKey] > b[columnKey]) {
        return newSortDirection === 'asc' ? 1 : -1;
      }
      return 0;
    });

    this.setState({
      data: sortedData,
      sortColumn: columnKey,
      sortDirection: newSortDirection,
    });
  };

  renderSortIcon = (columnKey) => {
    const { sortColumn, sortDirection } = this.state;
    if (sortColumn !== columnKey) {
      return null;
    }
    if (sortDirection === 'asc') {
      return <span> ▲</span>; 
    }
    return <span> ▼</span>; 
  };

  render() {
    const { columns } = this.props;
    const { data } = this.state;

    return (
      <div className="table-container">
        <table>
          <thead>
            <tr>
              {columns.map((column, index) => (
                <th key={index} onClick={() => this.handleSort(column.key)}>
                  {column.name}
                  {this.renderSortIcon(column.key)}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((item, index) => (
              <tr key={index}>
                {columns.map((column, columnIndex) => (
                  <td key={columnIndex}>{item[column.key]}</td>
                ))}
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    );
  }
}

export default GroupTable;
